// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

// components
import useStableSearchParams from '@/hooks/useStableSearchParams';

/**
 * Compact aggregation selector rendered as a mutually exclusive button group.
 * Reads/writes selection to the `agg` search param.
 */
const AggregationSelector = ({ param = 'agg' }) => {
  const { t } = useTranslation('dashboards-common');
  const [searchParams, setSearchParams] = useStableSearchParams();
  const current = searchParams.get(param) || 'day';

  const setAgg = (value) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (value) next.set(param, value);
      else next.delete(param);
      return next;
    });
  };

  const labelMap = {
    hour: t('aggregation.hour'),
    day: t('aggregation.day'),
    week: t('aggregation.week'),
    month: t('aggregation.month'),
  };

  return (
    <ToggleButtonGroup
      exclusive
      value={labelMap[current] ? current : 'week'}
      onChange={(_, value) => {
        if (value) setAgg(value);
      }}
      data-testid="agg-button"
    >
      {Object.entries(labelMap).map(([value, label]) => (
        <ToggleButton key={value} value={value} data-testid={`agg-${value}`}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default AggregationSelector;
